import { request, requestBlob } from './client';

/// Metadata-only description of a client-encrypted master-key wrap.
/// Deliberately mirrors `KeySummaryResponse`: the ciphertext blob and the
/// unlock secret are never requested by the browser account center.
export interface UnlockMethodSummary {
  kind: 'recovery_code' | 'passphrase' | string;
  version: number;
  created_at: string;
  last_used_at: string | null;
}

export function listUnlockMethods(): Promise<UnlockMethodSummary[]> {
  return request<UnlockMethodSummary[]>('/account/keys');
}

export type ExportStatus = 'queued' | 'building' | 'ready' | 'failed' | 'expired';
export interface DataExport {
  id: string; status: ExportStatus; failure_code: string | null; byte_count: number;
  changeset_count: number; dataset_count: number; wrapped_key_count: number;
  created_at: string; expires_at: string; download_token: string | null;
  download_token_expires_at: string | null;
}
export function listExports(): Promise<DataExport[]> { return request('/account/exports'); }
export function createExport(input: { password?: string; challenge?: string; totp_code?: string }): Promise<DataExport> {
  return request('/account/exports', { method: 'POST', body: input, noRetry: true });
}
export function getExport(id: string): Promise<DataExport> { return request(`/account/exports/${id}`); }
export function authorizeExportDownload(id: string): Promise<DataExport> {
  return request(`/account/exports/${id}/authorize`, { method: 'POST', noRetry: true });
}
export function beginExportTotpStepUp(): Promise<{ challenge: string; expires_at: string }> {
  return request('/account/exports/step-up', { method: 'POST', noRetry: true });
}
export function downloadExport(id: string, token: string): Promise<Blob> {
  return requestBlob(`/account/exports/${id}/download`, { method: 'POST', body: { token }, noRetry: true, timeoutMs: 120_000 });
}
